@if (dropDownsAreLoading()) {
  <lib-loader/>
} @else {
  @for (entry of dimensionItemsTreeMap(); track entry[0]) {
    <div>
      <lib-tree-dropdown
        data-test="dimension-filter-selector"
        [label]="entry[0]"
        [treeData]="entry[1] | treeNode"
        [labelKey]="'name'"
        (selectionChange)="onFilterSelected($event)"
        [selection]="filterItemsByDimensionName() | mapEntry : entry[0]"
        [filter]="true"
      />
    </div>
  }
}
